export function Categories(client) {
    return {
        get(active) {
            return client.get(`/categories?active=${active}`);
        }
    };
}
